import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ErrorsTooltipComponent } from '@shared/components/errors-tooltip/errors-tooltip.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import {
  AgIconLinkCellComponentIcon,
  AgIconLinkCellComponentParams,
} from './ag-icon-link-cell.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, IconComponent, NgClass, ErrorsTooltipComponent],
  styleUrls: ['ag-icon-link-cell.component.scss'],
  templateUrl: 'ag-icon-link-cell.component.html',
})
export class AgIconLinkCellComponent implements ICellRendererAngularComp {
  cellClass!: string;
  params!: AgIconLinkCellComponentParams;
  value!: string;

  agInit(params: AgIconLinkCellComponentParams): void {
    this.params = params;
    this.value = this.params.valueFormatted || this.params.value;
  }

  onIconClick(icon: AgIconLinkCellComponentIcon): void {
    if (!icon.iconDisabled && icon.iconClick) {
      icon.iconClick(this.params);
    }
  }

  onTextClick(): void {
    if (!this.params.textDisabled && this.params.textClick) {
      this.params.textClick(this.params);
    }
  }

  refresh(): boolean {
    return false;
  }

  textTooltip(offsetWidth: number, scrollWidth: number): string {
    if (this.params.textTooltipMessages?.length && this.params.textTooltipMessages.length === 1) {
      return this.params.textTooltipMessages[0];
    }

    return offsetWidth < scrollWidth ? this.value : '';
  }
}
